import React, { useEffect } from "react";

function IframeErrorListener({
  iframeId,
  setErrors,
}: {
  iframeId: string;
  setErrors: React.Dispatch<React.SetStateAction<never[]>>;
}) {
  useEffect(() => {
    function handleMessage(event) {
      // Optional: filter by event.origin if you want security
      // if (event.origin !== 'https://your-iframe-origin.com') return;

      // Only handle our specific error messages
      if (
        event.data &&
        event.data.type === "iframe-error" &&
        event.data.iframeId === iframeId
      ) {
        // Do whatever you need with the error info!
        // console.error("Iframe error from", event.data.iframeId, event.data);
        setErrors(prevItems => [...prevItems, event.data]);
        // For example, show in UI, log, send to server, etc.
      }
    }

    window.addEventListener("message", handleMessage);

    // Cleanup
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return null; // or return error UI
}

export default IframeErrorListener;
